<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<button v-if="openPage === false &&
					(landingPage.length === 0 || productPages.length === 0)
					" class="btn btn-default" @click="openPage = true">
					+ Tambah URL Landing Page
				</button>
				<div class="row mb-4" v-if="productPages.length > 0 || openPage">
					<div class="col-sm-4">
						<!-- URL -->
						<div class="form-group mb-1">
							<select class="input form-control" v-model="landingPage.type">
								<option v-for="(pageType, index) in pageTypes" :key="index" :value="pageType"
									:disabled="pageType.disabled">
									{{ pageType.label }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-sm-5">
						<!-- URL -->
						<div class="form-group mb-1" v-if="landingPage.type.value === 'orderonline'">
							<input ref="inputLP" v-focus @keyup.enter="addLandingPage"
								placeholder="Masukan Link Share Page Anda" type="text" class="input form-control"
								v-model.trim="landingPage.url" />
						</div>
						<!-- Upload -->
						<div class="form-group mb-1" v-else-if="landingPage.type.value === 'berdu' || landingPage.type.value === 'wordpress' ">
							<button class="btn btn-primary" @click="uploadFile">
								Upload File JSON
							</button>
						</div>
					</div>
					<div class="col-sm-3" v-if="landingPage.type.value === 'orderonline'">
						<div class="form-group mb-1">
							<button class="btn btn-primary btn-block" :disabled="productPages.length >= 5" v-tooltip="productPages.length >= 5
								? 'Sudah mencapai maksimal penambahan url'
								: 'Masukan hingga 5 url landing page'
								" @click="addLandingPage">
								+ Tambah
							</button>
						</div>
					</div>
				</div>
				<div v-for="(page, index) in productPages" :key="index" class="form-group">
					<div class="well">
						<label><b>{{ page.type.label }}</b></label>
						<div class="row">
							<div class="col-md-5">
								<div class="form-group mb-1">
									<select class="input form-control" v-model="page.type">
										<option v-for="(pageType, index) in pageTypes" :key="index" :value="pageType"
											:disabled="pageType.disabled">
											{{ pageType.label }}
										</option>
									</select>
								</div>
							</div>
							<div class="col-md-7">
								<div class="input-page-group">
									<input class="input form-control input-page" v-model="page.url" />
									<i class="material-icons form-control-page text-danger mt-1"
										v-tooltip="'Hapus Halaman ini'" @click="removeLandingPage(index)">
										close
									</i>
								</div>
							</div>
						</div>
						<div v-if="openLinkPreview ||
							(page.previews && page.previews.length > 0)
							" class="row mt-2">
							<div class="col-md-12 mt-1 mb-2">
								<ol style="padding-inline-start: 20px">
									<li v-for="(preview, i) in page.previews" :key="i">
										<a :href="preview.url" target="_blank">{{
											preview.title
										}}</a>
										<i class="material-icons text-danger cursor-pointer" style="font-size: 18px"
											v-tooltip="'Hapus preview'" @click="removePreview(index, i)">
											close
										</i>
									</li>
								</ol>
								<label> Judul Preview </label>
								<div class="input-page-group">
									<input ref="linkPreview" class="input form-control input-page mb-2"
										v-model="input_preview_title[index]" @keyup.enter="addPreview(index)" />
								</div>
								<label> Masukan URL Preview </label>
								<div class="input-page-group">
									<input class="input form-control input-page mb-3" v-model="input_preview_url[index]"
										@keyup.enter="addPreview(index)" />
								</div>
								<div class="input-page-group justify-content-end">
									<button class="btn btn-primary align-items-end" @click="addPreview(index)">
										Tambahkan Preview
									</button>
								</div>
							</div>
						</div>
						<div v-else class="row">
							<div class="col-md-12">
								<span class="link" @click="openPreview(index)">+ Tambahkan link preview</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group buttons m-0 hidden">
			<input type="file" class="input-file" ref="fileUploader" id="pc-product-images-file" @change="onFileChange" />
		</div>
	</div>
</template>

<script>
import mediaApi from '@/api/media';
import { duplicateVar } from '@/lib/helper';
import { defaultLandingPage, defaultPageTypes } from '@/lib/statics';

export default {
	props: {
		productPages: {
			type: [Array, Object],
			default: () => [],
		},
	},
	data() {
		return {
			openPage: false,
			landingPage: duplicateVar(defaultLandingPage),
			pageTypes: duplicateVar(defaultPageTypes),
			openLinkPreview: false,
			input_preview_title: [],
			input_preview_url: [],
			previews: [],
		};
	},
	methods: {
		onFileChange(event) {
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('file', image);
				uploadParams.append('resize', false);

				const callback = (response) => {
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					this.landingPage.url = url;
					this.addLandingPage();
				};

				const errorCallback = (e) => {
					// eslint-disable-next-line
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadFile(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		uploadFile() {
			const inputFile = this.$refs.fileUploader;
			inputFile.click();
		},
		openPreview() {
			this.openLinkPreview = true;
		},
		addPreview(index) {
			const title = this.input_preview_title[index];
			const url = this.input_preview_url[index];
			const option = {
				title,
				url,
			};
			this.$emit('add-preview', {
				index,
				option,
			});
			this.input_preview_url[index] = '';
			this.input_preview_title[index] = '';
		},
		removePreview(index, i) {
			this.$emit('remove-preview', {
				index,
				i,
			});
		},
		addLandingPage() {
			if (this.productPages.length < 5) {
				this.$emit('add-lp', duplicateVar(this.landingPage));
				this.landingPage = {
					type: {
						value: 'orderonline',
						label: 'Order Online',
						disabled: false,
					},
					url: '',
					previews: [],
				};
				this.$refs.inputLP.focus();
			}
		},
		removeLandingPage(index) {
			if (this.productPages.length > 0) {
				this.$emit('remove-lp', index);
			}
		},
	},
};
</script>
